import React from 'react';
import account, { Account } from './modules/account';
import auth, { Auth } from './modules/auth';
import product, { Product } from './modules/product';
import site, { Site } from './modules/site';

export type RootStore = {
  auth: Auth;
  account: Account;
  product: Product;
  site: Site;
};

export const store: RootStore = {
  auth,
  account,
  product,
  site
};

const StoreContext = React.createContext<RootStore>(store);

export const StoreProvider = StoreContext.Provider;

export const useStore = () => React.useContext(StoreContext);

export { auth, account, product, site };
